// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import Move from "@insite/mobius/Icons/Move";
import dataTableStyles from "@tps/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { productListStyles } from "@tps/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import { color, mergeWithCss, modalButtonsActionStyles, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productListStyles.centeringWrapper = {
    ...dataTableStyles.centeringWrapper,
};

productListStyles.messageText = {
    ...dataTableStyles.noResultsText,
};

productListStyles.sortOrderWrapper = {
    css: css`
        padding: 17px;
        margin-top: 1px;
        position: absolute;
        top: 50%;
        z-index: 1;
        line-height: 1;
        width: 50px;
        height: 50px;
        transform: translate(0, -50%);
        background-color: ${color("common.ui2")};
        @media print {
            display: none;
        }
        ${xScreen("lte", "md")} {
            margin: 0;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
        }
    `,
};

productListStyles.dragHandleIcon = {
    src: Move,
    size: 16,
    css: css`
        cursor: move;
        margin: 0 auto;
    `,
};

productListStyles.lineGridItem = {
    width: 12,
    css: css`
        position: relative;
        border-bottom: 1px solid ${color("common.border")};
        &:last-child {
            border-bottom: 0;
        }
        @media print {
            &:last-child {
                border-bottom: 1px solid ${color("common.border")};
            }
        }
    `,
};

productListStyles.container = {
    gap: 0,
    css: css`
        /* Note: below line is to prevent a weird behavior where chrome wants to print anything that will fit
        * comprehensively on a single page on that page, which means the product list appears on page 2
        when rendering a common 8-item list with no notes. That's not ideal, so we're arbitrarily making
        the component large enough that it won't fit on a single page. */
        @media print {
            padding-bottom: 120px;
            page-break-before: avoid;
        }
    `,
};

productListStyles.notesTextArea = {
    placeholder: translate("Notes"),
};

productListStyles.wrapper = {
    css: css`
        margin: 20px 0;
        box-shadow: 0 0 8px 0 ${color("common.ui5", 0.15)};
    `,
};

productListStyles.titleWrapper = {
    css: css`
        background-color: ${color("common.ui2")};
        padding: 15px 20px;
    `,
};

productListStyles.titleText = {
    size: 20,
};

productListStyles.deleteListItemModal = {
    buttonsGridItem: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    submitButton: {
        color: "primary",
    },
};

productListStyles.editNotesModalButtonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

productListStyles.editNotesModalCancelButton = {
    variant: "secondary",
};
